export default "__VITE_ASSET__e399900a__"